/* Casca Rija: Metricool website visits, explicit analytics consent required.
 * Never put this asset on the private retention/customer activation origin.
 * No customer IDs, offer tokens, coupons, orders or conversion events are sent.
 */
(function () {
  'use strict';
  const hash = 'd3d0a84a38a91b1a9de9be5fa32f040e';
  if (window.__cascarijaMetricool) return;
  const state = window.__cascarijaMetricool = {hash: hash, status: 'waiting_consent', requested: false, sent: false};
  const privatePath = /(?:^|\/)(?:accounts?|customers?|checkouts?|orders?|discount|cart|retention|activate|preferences|unsubscribe|login)(?:\/|$)/i;
  function safeLocation() {
    try {
      const url = new URL(window.location.href);
      if (url.protocol !== 'https:' || url.username || url.password || url.hash || privatePath.test(url.pathname)) return false;
      const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
      let publicPath = url.pathname;
      if (root !== '/' && /^\/[a-z]{2}(?:-[A-Za-z0-9]{2,8})?\/$/.test(root)) {
        const prefix = root.slice(0, -1);
        if (publicPath === prefix) publicPath = '/';
        else if (publicPath.indexOf(root) === 0) publicPath = publicPath.slice(root.length - 1);
      }
      if (!/^(?:\/$|\/(?:products|collections|blogs|pages)(?:\/|$)|\/search$)/.test(publicPath)) return false;
      // Short campaign labels and non-personal variant/pagination options only.
      for (const [key, value] of url.searchParams) {
        if (/^utm_(source|medium|campaign|content|term)$/.test(key) && /^[a-zA-Z0-9_-]{1,31}$/.test(value)) continue;
        if (key === 'variant' && /^[0-9]{1,20}$/.test(value)) continue;
        if (key === 'page' && /^[0-9]{1,4}$/.test(value)) continue;
        return false;
      }
      // beTracker forwards document.referrer verbatim, not only its origin.
      if (document.referrer) {
        const referrer = new URL(document.referrer);
        if (referrer.username || referrer.password || referrer.hash || referrer.search || privatePath.test(referrer.pathname)) return false;
      }
      return true;
    } catch (_) { return false; }
  }
  if (!safeLocation()) { state.status = 'private_or_unsafe_url'; return; }
  function analyticsAllowed() {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      // Strict explicit consent even if a regional setting permits tracking by default.
      return !!privacy && privacy.analyticsProcessingAllowed() === true && privacy.currentVisitorConsent().analytics === 'yes';
    } catch (_) { return false; }
  }
  function recordVisit() {
    if (state.sent || !analyticsAllowed() || !safeLocation()) { if (!state.sent) state.status = 'consent_or_url_changed'; return; }
    if (!window.beTracker || typeof window.beTracker.t !== 'function') { state.status = 'tracker_unavailable'; return; }
    state.sent = true; // Fail closed on exceptions; never replay an ambiguous visit.
    try { window.beTracker.t({hash: hash}); state.status = 'visit_requested'; }
    catch (_) { state.status = 'tracker_error'; }
  }
  function maybeLoad() {
    if (state.requested || state.sent || !analyticsAllowed() || !safeLocation()) return;
    state.requested = true; state.status = 'loading';
    const script = document.createElement('script');
    script.type = 'text/javascript'; script.async = true;
    script.src = 'https://tracker.metricool.com/resources/be.js';
    script.referrerPolicy = 'no-referrer';
    script.onload = recordVisit;
    script.onerror = function () { state.status = 'tracker_blocked_or_failed'; };
    document.head.appendChild(script);
  }
  let featureRequested = false;
  function initializePrivacy() {
    maybeLoad();
    if (window.Shopify && !window.Shopify.customerPrivacy && typeof window.Shopify.loadFeatures === 'function' && !featureRequested) {
      featureRequested = true;
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function (error) {
        if (!error) maybeLoad(); else state.status = 'privacy_api_unavailable';
      });
    }
  }
  document.addEventListener('visitorConsentCollected', maybeLoad);
  window.addEventListener('load', initializePrivacy, {once: true});
  initializePrivacy();
})();
